<template>
    <v-row no-gutters v-if="className == 'full'">
        <v-col cols="12" class="line-layout-tit-wrap mb-20 mb-lg-40">
            <h5 class="tit--sm font-weight-medium line-layout-tit">
                {{tit}}
            </h5>
        </v-col>
        <v-col cols="12">
            <slot/>
        </v-col>
    </v-row>
    <v-row no-gutters v-else>
        <v-col cols="12" lg="auto" class="line-layout-tit-wrap mb-20 mb-lg-0">
            <h5 class="tit--sm font-weight-medium line-layout-tit">
                {{tit}}
            </h5>
        </v-col>
        <v-col cols="12" lg="auto" class="line-layout-content pl-lg-40">
            <slot/>
        </v-col>
    </v-row>
</template>

<script>

export default{
    props : {
        className : {type :String, default : ""},
        tit : {type :String, default : ""},
    },
    components: {
    },
    data: () => {
        return {
        }
    },
	created() {
	},
	// mounted() {
	// 	this.init();
	// },
	// methods : {
	// 	init : function() {
    //         setTimeout(() => {
    //             AOS.init({
    //                 once: false,
    //                 offset: 240,
    //                 duration: 500,
    //                 throttleDelay : 100,
    //                 easing : 'ease-in-out',
    //                 anchorPlacement : 'top-center',
    //             });
    //         }, 100);
	// 	}
	// },
}
</script>

<style scoped>
.line-layout-tit{
    width: fit-content;
    padding-top: 6px;
    position: relative;
}
.line-layout-tit::before{
    content: "";
    display: block;
    position: absolute;
    width: 100%;
    height: 1px;
    background-color: #111;
    top: 0;
    left: 0;
}
@media (min-width:576px){
}
@media (min-width:768px){
}
@media (min-width:1024px){
    .line-layout-tit-wrap{
        width: 210px;
    }
    .line-layout-content{
        width: calc(100% - 210px);
    }
    .line-layout-tit{
        width: 100%;
        padding-top: 10px;
    }
    .line-layout-tit::before{
       height: 2px;
       max-width: 210px;
    }
}
@media (min-width:1200px){
}

</style>